import React from "react";
//import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

class Sidebar extends React.Component {
  render() {
    return (
      <Paper style={{ paddingTop: 8, paddingBottom: 8, paddingLeft: 20, paddingRight: 20 }}>
        <Typography>
          <h2>客演指揮者の先生</h2>
          <ul>
            <li><a href="http://www.musicinfo.com/takubo/" target="_">田久保 裕一</a></li>
            <li><a href="http://qchan-dirigent.cocolog-nifty.com" target="_">松岡 究</a></li>
          </ul>
          <h2>お問い合わせ</h2>
          <ul>
            <li>Mail: <a href="mailto:obsym.mail@gmail.com">obsym.mail@gmail.com</a></li>
          </ul>
          <h2>リンク</h2>
          <ul>
            <li><a href="https://i-amabile.com/orchestra/ob_sym" target="_">i-Amabile</a></li>
          </ul>
        </Typography>
      </Paper>
    );
  }
}

export default Sidebar;
